module.exports = __webpack_public_path__ + "d93c8a9829b5dcc28486af438894286c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00009ABP.png
// module id = 1702
// module chunks = 0